import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';

const $input = $('input, textarea');

$input.on('focus', function(){
	$(this).closest('.gfield').find('label').addClass('away');
});

$input.on('blur', function(){
	if( !$(this).val() ){
		$(this).closest('.gfield').find('label').removeClass('away');
	}
});

$('input[type="file"]').on('focus', function(){
	$(this).closest('.gfield').find('label').addClass('focus');
});
$('input[type="file"]').on('blur', function(){
	$(this).closest('.gfield').find('label').removeClass('focus');
});

//datepicker for hero form
$('#arrival').datepicker({
    dateFormat: 'mm/dd/yy',
	minDate: new Date,
	onSelect: (date, inst) => {
		const min = new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay + 4)
		$('#departure').datepicker('option', 'minDate', min);
		$('[name=wpbs-search-start-date]').val(`${inst.selectedYear}-${inst.selectedMonth+1}-${inst.selectedDay}`)
	}
})
$('#departure').datepicker({
    dateFormat: 'mm/dd/yy',
	onSelect: (date, inst) => {
		$('[name=wpbs-search-end-date]').val(`${inst.selectedYear}-${inst.selectedMonth+1}-${inst.selectedDay}`)
	}
})
